// Аварийный фолбэк клиентского роутера. Источник правды — /get_redirects на
// бэке: там слагов больше, и оттуда же nginx снимает слепок для серверных 301
// (config/nginx.conf.erb). Сюда попадает только то, что должно работать даже
// при недоступном API.
//
// Цели — ЧПУ, а не /purchase: последний сам отдаёт 301, и переход по слагу
// стоил бы лишнего прыжка.
export const REDIRECT_ROUTES = {
  test_redirect_main:
    '?utm_source=test_source&utm_medium=test_medium_main&utm_campaign=test_campaign_main&utm_content=test_content_main&utm_term=test_term_main',
  test_redirect_transfer_promo:
    'transfer?utm_source=test_source&utm_medium=test_medium_main&utm_campaign=test_campaign_main&utm_content=test_content_main&utm_term=test_term_main',
  test_redirect_giftcards:
    'giftcards?utm_source=test_source&utm_medium=test_medium_giftcards&utm_campaign=test_campaign_giftcards&utm_content=test_content_giftcards&utm_term=test_term_giftcards',
  test_redirect_superpass:
    'superpass?utm_source=test_source&utm_medium=test_medium_superpass&utm_campaign=test_campaign_superpass&utm_content=test_content_superpass&utm_term=test_term_superpass',
  TamerGlass:
    'transfer?utm_source=youtube&utm_medium=blogger&utm_campaign=transfer&utm_content=TamerGlass&utm_term=preroll_february2026&promo=TTG10',
  love:
    'transfer?utm_source=general&utm_medium=general&utm_campaign=transfer&utm_content=general&utm_term=general_february2026&promo=LOVE',
  penoplast:
    'transfer?utm_source=youtube&utm_medium=penoplast&utm_campaign=transfer&utm_content=preroll&utm_term=PENOPLAST&promo=PENOPLAST',
  tamerglass:
    'transfer?utm_source=youtube&utm_medium=TamerGlass&utm_campaign=transfer&utm_content=preroll&utm_term=TTG10&promo=TTG10',
  haman:
    'transfer?utm_source=youtube&utm_medium=haman&utm_campaign=transfer&utm_content=preroll&utm_term=HAMAN&promo=HAMAN',
  zayac:
    'transfer?utm_source=youtube&utm_medium=zayac&utm_campaign=transfer&utm_content=preroll&utm_term=KIBER&promo=KIBER',
  iziks:
    'transfer?utm_source=youtube&utm_medium=iziks&utm_campaign=transfer&utm_content=preroll&utm_term=IZIKS&promo=IZIKS',
  kriker:
    'transfer?utm_source=youtube&utm_medium=kriker&utm_campaign=transfer&utm_content=preroll&utm_term=KRIKER&promo=KRIKER',
  sheggich:
    'transfer?utm_source=youtube&utm_medium=sheggich&utm_campaign=transfer&utm_content=preroll&utm_term=SHEGGICH&promo=SHEGGICH',
  bleniks:
    'transfer?utm_source=youtube&utm_medium=bleniks&utm_campaign=transfer&utm_content=preroll&utm_term=BLENIKS&promo=BLENIKS',
  banzigo:
    'transfer?utm_source=youtube&utm_medium=banzigo&utm_campaign=transfer&utm_content=preroll&utm_term=BANZIGO&promo=BANZIGO',
  pig:
    'transfer?utm_source=youtube&utm_medium=pig&utm_campaign=transfer&utm_content=preroll&utm_term=MRPIG&promo=MRPIG',
  lendik:
    'transfer?utm_source=youtube&utm_medium=lendik&utm_campaign=transfer&utm_content=preroll&utm_term=LENDIK&promo=LENDIK',
  clowny:
    'transfer?utm_source=youtube&utm_medium=clowny&utm_campaign=transfer&utm_content=preroll&utm_term=CLOWNY&promo=CLOWNY',
  ksizich:
    'transfer?utm_source=youtube&utm_medium=ksizich&utm_campaign=transfer&utm_content=preroll&utm_term=KSIZICH&promo=KSIZICH',
  kiril:
    'transfer?utm_source=youtube&utm_medium=kiril&utm_campaign=transfer&utm_content=preroll&utm_term=KIRILVIDS&promo=KIRILVIDS',
  kozzi:
    'transfer?utm_source=youtube&utm_medium=kozzi&utm_campaign=transfer&utm_content=preroll&utm_term=KOZI&promo=KOZI',
  tyomoff:
    'transfer?utm_source=youtube&utm_medium=tyomoff&utm_campaign=transfer&utm_content=preroll&utm_term=TEMOFF&promo=TEMOFF',
  tasty:
    'transfer?utm_source=youtube&utm_medium=tasty&utm_campaign=transfer&utm_content=preroll&utm_term=TASTY15&promo=TASTY15',
  divan:
    'transfer?utm_source=youtube&utm_medium=divan&utm_campaign=transfer&utm_content=preroll&utm_term=DIVAN&promo=DIVAN',
  pashich:
    'transfer?utm_source=youtube&utm_medium=pashich&utm_campaign=transfer&utm_content=preroll&utm_term=PASHICH&promo=PASHICH',
  gans:
    'transfer?utm_source=youtube&utm_medium=gans&utm_campaign=transfer&utm_content=preroll&utm_term=GANS&promo=GANS',
  semechka:
    'transfer?utm_source=youtube&utm_medium=semechka&utm_campaign=transfer&utm_content=preroll&utm_term=SEME4KA&promo=SEME4KA',
  niplin:
    'transfer?utm_source=youtube&utm_medium=niplin&utm_campaign=transfer&utm_content=preroll&utm_term=NIPLIN&promo=NIPLIN',
  zhandos:
    'transfer?utm_source=youtube&utm_medium=zhandos&utm_campaign=transfer&utm_content=preroll&utm_term=ZHAN&promo=ZHAN',
  benzo:
    'transfer?utm_source=youtube&utm_medium=benzo&utm_campaign=transfer&utm_content=preroll&utm_term=BENZOPIL&promo=BENZOPIL',
  bonchik:
    'transfer?utm_source=youtube&utm_medium=bonchik&utm_campaign=transfer&utm_content=preroll&utm_term=SPROBUX&promo=SPROBUX',
  dambon:
    'transfer?utm_source=youtube&utm_medium=dambon&utm_campaign=transfer&utm_content=preroll&utm_term=FREE&promo=FREE',
  pajnepl:
    'transfer?utm_source=youtube&utm_medium=pajnepl&utm_campaign=transfer&utm_content=preroll&utm_term=PAJNEPL&promo=PAJNEPL',
  strict:
    'transfer?utm_source=youtube&utm_medium=strict&utm_campaign=transfer&utm_content=preroll&utm_term=STRICT&promo=STRICT',
  tejzti:
    'transfer?utm_source=youtube&utm_medium=tejzti&utm_campaign=transfer&utm_content=preroll&utm_term=TEYZTI&promo=TEYZTI',
  nilc:
    'transfer?utm_source=youtube&utm_medium=nilc&utm_campaign=transfer&utm_content=preroll&utm_term=NILC&promo=NILC',
  noriks:
    'transfer?utm_source=youtube&utm_medium=noriks&utm_campaign=transfer&utm_content=preroll&utm_term=NORIX&promo=NORIX',
  rin:
    'transfer?utm_source=youtube&utm_medium=rin&utm_campaign=transfer&utm_content=preroll&utm_term=RIN30&promo=RIN30',
  fun:
    'transfer?utm_source=youtube&utm_medium=fun&utm_campaign=transfer&utm_content=preroll&utm_term=FUN30&promo=FUN30',
  chous:
    'transfer?utm_source=youtube&utm_medium=chous&utm_campaign=transfer&utm_content=preroll&utm_term=CHOUS30&promo=CHOUS30',
  skechi:
    'transfer?utm_source=youtube&utm_medium=skechi&utm_campaign=transfer&utm_content=preroll&utm_term=SKECHI&promo=SKECHI',
  ipix:
    'transfer?utm_source=youtube&utm_medium=ipix&utm_campaign=transfer&utm_content=preroll&utm_term=IPIX30&promo=IPIX30',
  kot:
    'transfer?utm_source=youtube&utm_medium=kot&utm_campaign=transfer&utm_content=preroll&utm_term=BLACKCAT&promo=BLACKCAT',
  wh1te:
    'transfer?utm_source=youtube&utm_medium=wh1te&utm_campaign=transfer&utm_content=preroll&utm_term=WH1TE&promo=WH1TE',
  mintik:
    'transfer?utm_source=youtube&utm_medium=mintik&utm_campaign=transfer&utm_content=preroll&utm_term=MINTIK&promo=MINTIK',
  tajma:
    'transfer?utm_source=youtube&utm_medium=tajma&utm_campaign=transfer&utm_content=preroll&utm_term=TAIMA30&promo=TAIMA30'
}
